import PropTypes from 'prop-types';
import { useState, useEffect, useContext } from 'react';
import GenericField, { INTERNAL_ICON } from '../../formField/genericField';
import FormFieldDate from '../../formField/date';
import FormFieldDrop from '../../formField/drop';
import FormFieldCheckbox from '../../formField/checkbox';
import * as walletService from '../../../services/wallet';
import * as userService from '../../../services/user';
import FormRow from '../../formRow';
import LoadScreen from '../../../view/load';
import { DateTimeNow } from '../../../utils/date';
import Popup from '../layout';

const PopUpSchedule = ({ addSchedule, visible, setVisible, selectedSchedule = null }) => {
  const [schedule, setSchedule] = useState(null);
  const [date, setDate] = useState(DateTimeNow());
  const [description, setDescription] = useState(null);
  const [concluded, setConcluded] = useState(false);
  const [responsible, setResponsible] = useState(null);
  const [responsibles, setResponsibles] = useState([]);
  const [loading, setLoading] = useState(false);

  const confirmAddSchedule = () => {
    const item = {
      Data: date,
      Descricao: description,
      SituacaoId: concluded ? 1 : 0,
      ResponsavelId: responsible?.Email
    };
    addSchedule(item);
    setDescription(null);
    setDate(DateTimeNow());
    setConcluded(false);
    setResponsible(null);
  };

  const loadResponsibles = async () => {
    const { data } = await walletService.getUsers();
    setResponsibles(data);
    return data;
  };

  useEffect(async () => {
    if (visible) {
      setLoading(true);
      const responsibles = await loadResponsibles();
      if (selectedSchedule) {
        setSchedule(selectedSchedule);
        setDate(selectedSchedule.Data);
        setDescription(selectedSchedule.Descricao);
        if (selectedSchedule.SituacaoId === 1) setConcluded(true);
        else setConcluded(false);
        const responsible = responsibles.find(
          (element) => element.Id === selectedSchedule.ResponsavelId
        );
        setResponsible(responsible);
      } else {
        setSchedule(null);
        setDate(DateTimeNow());
        setDescription(null);
        setConcluded(false);
        const { data } = await userService.recoverCompleteUser();
        const responsible = responsibles.find((element) => element.Id === data.Id);
        setResponsible(responsible);
      }
      setLoading(false);
    }
  }, [selectedSchedule, visible]);

  return (
    <Popup
      title={selectedSchedule ? 'Atualizar Agenda' : 'Adicionar Agenda'}
      width={900}
      visible={visible}
      setVisible={setVisible}
      confirmText={selectedSchedule ? 'Atualizar' : 'Adicionar'}
      cancelText="Cancelar"
      onConfirm={confirmAddSchedule}
    >
      {loading ? (
        <LoadScreen />
      ) : (
        <>
          <FormRow withShrink>
            <FormFieldDate
              titleLabel="Data"
              value={date}
              valueOnChange={setDate}
              className="fill-35-field"
              required
              calendarIsTime
            />

            <FormFieldDrop
              titleLabel="Responsável"
              defaultValueSelect="Selecione..."
              onChangeValue={(val) => {
                setResponsible(val.value);
              }}
              value={responsible}
              className="fill-50-field"
              infosSelect={responsibles}
              dataItemKey="Id"
              textField="Nome"
              required
            />
            <FormFieldCheckbox
              label="Concluído"
              classNameWrapper="fill-15-field"
              value={concluded}
              onChange={(val) => {
                setConcluded(val.value);
              }}
            />
          </FormRow>
          <FormRow>
            <GenericField
              titleLabel="Título"
              placeholder="Escreva título"
              classNameWrapper="fill-100-field"
              isTextArea
              rows={6}
              valueInput={description}
              onChangeValue={(val) => {
                setDescription(val.value);
              }}
              required
            />
          </FormRow>
        </>
      )}
    </Popup>
  );
};

PopUpSchedule.propTypes = {
  addSchedule: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired
};

PopUpSchedule.defaultProps = {};

export default PopUpSchedule;
